/* TypeScript file generated from TooltipIcon.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as TooltipIconJS from './TooltipIcon.res.js';

import type {Overlay_Position_placement as ReactAria_Overlay_Position_placement} from '../../../src/externals/ReactAria.gen';

export type variation = "info" | "alert" | "quiet_info" | "quiet_more";

export type props<children,variation,arrowed,placement,altTriggerRef,offset,crossOffset,iconSize> = {
  readonly children: children; 
  readonly variation?: variation; 
  readonly arrowed?: arrowed; 
  readonly placement?: placement; 
  readonly altTriggerRef?: altTriggerRef; 
  readonly offset?: offset; 
  readonly crossOffset?: crossOffset; 
  readonly iconSize?: iconSize
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly variation?: variation; 
  readonly arrowed?: boolean; 
  readonly placement?: ReactAria_Overlay_Position_placement; 
  readonly altTriggerRef?: any; 
  readonly offset?: number; 
  readonly crossOffset?: number; 
  readonly iconSize?: number
}> = TooltipIconJS.make as any;
